import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import * as Sentry from '@sentry/react'
import { initSentry } from './lib/sentry'
import App from './App'
import './styles/global.css'

// Must run before React renders so the SDK can capture early errors.
initSentry()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30s — most data is fresh enough
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div style={{ padding: 24, color: 'var(--color-text)' }}>
          <h1>Something broke.</h1>
          <p>The error was logged. Reload the page to keep going.</p>
          <button onClick={resetError} style={{ padding: '8px 16px', marginTop: 12 }}>
            Reload
          </button>
        </div>
      )}
    >
      <QueryClientProvider client={queryClient}>
        <App />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
